module.exports = __webpack_public_path__ + "cc6c25567ee136bb129e0689cc685505.MP3";